module.exports = __webpack_public_path__ + "static/img/topBgcBgc.e7adc1a1.png";